import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPersonRunning, faMapLocationDot, faChartLine, faUsers } from '@fortawesome/free-solid-svg-icons';

const MobileAppDownload = () => {
  return (
    <div className="min-h-screen bg-[#FDFDFC] flex items-center justify-center p-6">
      <div className="max-w-lg w-full">
        <div className="mb-12 text-center">
          <div className="w-28 h-28 bg-[#5B7EA4] rounded-card mx-auto flex items-center justify-center border border-[#ECECEC] mb-8">
            <FontAwesomeIcon icon={faPersonRunning} className="text-5xl text-white" />
          </div>
          
          <h1 className="text-h1 text-[#2A2E36] font-semibold mb-3 tracking-tight">
            ZoneRuns Mobile App
          </h1>
          
          <p className="text-body text-[#AAC4D6] max-w-md mx-auto leading-relaxed">
            Track your runs, connect with friends, and explore new routes. Download our mobile app for the complete experience.
          </p>
        </div>

        <div className="scrapbook-container p-8 mb-8">
          <div className="space-y-6">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-card bg-[#DCEAF2] flex items-center justify-center flex-shrink-0">
                <FontAwesomeIcon icon={faMapLocationDot} className="text-[#5B7EA4] w-5 h-5" />
              </div>
              <div>
                <h3 className="text-h3 text-[#2A2E36] font-semibold mb-1">Real-time GPS Tracking</h3>
                <p className="text-body-sm text-[#AAC4D6]">Accurate route tracking with live pace and distance updates</p>
              </div>
            </div>
            
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-card bg-[#DCEAF2] flex items-center justify-center flex-shrink-0">
                <FontAwesomeIcon icon={faUsers} className="text-[#5B7EA4] w-5 h-5" />
              </div>
              <div>
                <h3 className="text-h3 text-[#2A2E36] font-semibold mb-1">Social Running</h3>
                <p className="text-body-sm text-[#AAC4D6]">Connect with friends and share your progress</p>
              </div>
            </div>
            
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-card bg-[#DCEAF2] flex items-center justify-center flex-shrink-0">
                <FontAwesomeIcon icon={faChartLine} className="text-[#5B7EA4] w-5 h-5" />
              </div>
              <div>
                <h3 className="text-h3 text-[#2A2E36] font-semibold mb-1">Detailed Analytics</h3>
                <p className="text-body-sm text-[#AAC4D6]">Comprehensive insights into your performance</p>
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-4 mb-10">
          <a
            href="https://apps.apple.com"
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full hover:scale-[1.02] active:scale-[0.98] transition-transform duration-200"
          >
            <img 
              src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1708992000"
              alt="Download on the App Store"
              className="w-full h-auto max-w-[180px] mx-auto"
            />
          </a>

          <a
            href="https://play.google.com"
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full hover:scale-[1.02] active:scale-[0.98] transition-transform duration-200"
          >
            <img 
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
              alt="Get it on Google Play"
              className="w-full h-auto max-w-[200px] mx-auto"
            />
          </a>
        </div>

        <div className="text-center">
          <p className="text-body-sm text-[#AAC4D6]">
            This web experience is optimized for desktop.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MobileAppDownload;
